import {
  GET_ALL_LEAVES,
  GET_JOB_TITLES,
  GET_ROLES,
  GET_OFFICES,
  GET_EVENT_CAT,
  GET_SUBCATEGORIES,
} from "../../actionTypes";

const initialState = {
  allLeaves: [],
  roles: [],
  jobtitles: [],
  offices: [],
  eventCat: [],
  subcategories: [],
  requestType: [],
  individualRequestsCategories: [],
  officeRequestsCategories: [],
};

export const systemConfigReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_ALL_LEAVES:
      return {
        ...state,
        allLeaves: payload.leave,
      };

    case GET_JOB_TITLES:
      return {
        ...state,
        jobtitles: payload.jobtitle,
      };

    case GET_ROLES:
      return {
        ...state,
        roles: payload.roles,
      };

    case GET_OFFICES:
      return {
        ...state,
        offices: payload.offices,
      };

    case GET_EVENT_CAT:
      return {
        ...state,
        eventCat: payload.data,
      };

    case GET_SUBCATEGORIES:
      return {
        ...state,
        subcategories: payload.categories,
        requestType: payload.requestType,
        individualRequestsCategories: payload.individualRequestsCategories,
        officeRequestsCategories: payload.officeRequestsCategories,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/actions/systemconfiguration/systemconfig.reducer.js